import type { PanoramaAttribution } from '../providers/types';

const LICENSE_URLS: Record<string, string> = {
  'CC-BY-SA-4.0': 'https://creativecommons.org/licenses/by-sa/4.0/deed.fr',
  'CC-BY-4.0': 'https://creativecommons.org/licenses/by/4.0/deed.fr',
  'etalab-2.0': 'https://www.etalab.gouv.fr/licence-ouverte-open-licence/',
  'CC0-1.0': 'https://creativecommons.org/publicdomain/zero/1.0/deed.fr',
};

function formatDate(iso?: string): string | null {
  if (!iso) return null;
  // Google gives "YYYY-MM", the others full ISO dates.
  const date = new Date(/^\d{4}-\d{2}$/.test(iso) ? `${iso}-01T00:00:00Z` : iso);
  if (Number.isNaN(date.getTime())) return null;
  return new Intl.DateTimeFormat('fr-FR', { month: 'long', year: 'numeric' }).format(date);
}

/**
 * Credits for the picture. During the round only the source is shown (the author's
 * name could give the location away); the full credits are shown on the result screen.
 */
export default function Attribution({ attribution, detailed = false }: { attribution: PanoramaAttribution; detailed?: boolean }) {
  if (!detailed) {
    return (
      <span className="attribution attribution--compact">
        Image : {attribution.sourceName}
        {attribution.license ? ` · ${attribution.license}` : ''}
      </span>
    );
  }
  const date = formatDate(attribution.capturedAt);
  const licenseUrl = attribution.license ? LICENSE_URLS[attribution.license] : undefined;
  return (
    <p className="attribution">
      Image {attribution.sourceName}
      {attribution.author ? ` · ${attribution.author}` : ''}
      {date ? ` · ${date}` : ''}
      {attribution.license && (
        <>
          {' · '}
          {licenseUrl ? (
            <a href={licenseUrl} target="_blank" rel="noopener noreferrer">
              {attribution.license}
            </a>
          ) : (
            attribution.license
          )}
        </>
      )}
    </p>
  );
}
